export default __webpack_public_path__ + "static/5a)OhOhhhh-280b0ef8a3b0ae1ce2978b1e51e5bfd1.mp3";